import { lazy } from 'react';

export const LoanbookAnalysis = lazy(() => import('./LoanbookAnalysis'));
